export default __webpack_public_path__ + "static/media/AdminLoginIllustration.1f24a435.svg";